<template>
    <el-scrollbar :style="{ height: winHeight }">
        <!-- Global Setting ================================================================ -->
        <table class="bm-table">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Global Settings</td>
            </tr>
            <tr>
                <td class="bm-structure-table-name" style="width: 210px;padding:5px;">
                    Representation
                </td>
                <td class="bm-table-ope">
                    <el-select v-model="global_structure_representation" placeholder="Select item">
                        <el-option v-for="item in options_structure_representation" :key="item.value"
                            :value="item.value"></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Background</td>
                <td class="bm-table-ope" style="margin: 5px 0px 0 10px !important">
                    <el-color-picker v-model="global_background" :predefine="predefineColors">
                    </el-color-picker>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Animation</td>
                <td class="bm-table-ope">
                    <el-switch v-model="global_animation" active-color="#a4b0be" inactive-color="#E4E7ED"></el-switch>
                </td>
            </tr>
        </table>
        <GlobalSurfaceSetting></GlobalSurfaceSetting>
        <!-- <CartoonSetting v-if="global_structure_representation === 'Cartoon'"></CartoonSetting> -->
        <!-- Selection Setting ================================================================== -->
        <table class="bm-table">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Selection Settings</td>
            </tr>
            <tr>
                <td class="bm-structure-table-name" style="width: 115px;">Representation</td>
                <td class="bm-table-ope">
                    <el-select v-model="selection_structure_representation" placeholder="Select item">
                        <el-option v-for="item in options_structure_representation" :key="item.value"
                            :value="item.value"></el-option>
                    </el-select>
                </td>
            </tr>
            <!-- <tr>
                <td class="bm-structure-table-name">Color</td>
                <td class="bm-table-ope">
                    <el-color-picker v-model="selection_color" :predefine="predefineColors">
                    </el-color-picker>
                </td>
            </tr>
            <tr>
                <td class="bm-structure-table-name">Effect</td>
                <td class="bm-table-ope">
                    <el-select v-model="selected_effect" placeholder="Select item">
                        <el-option v-for="item in options_selected_effect" :key="item.value" :value="item.value">
                        </el-option>
                    </el-select>
                </td>
            </tr> -->
            <!-- <tr>
                <td class="bm-structure-table-name">Focus</td>
                <td class="bm-table-ope">
                    <el-switch v-model="selected_focus" active-color="#a4b0be" inactive-color="#E4E7ED">
                    </el-switch>
                </td>
            </tr> -->
        </table>
        <!-- <i class="el-icon-question"></i>
                In the <strong>Sequence Viewer</strong>, <strong> Mouse swipe the sequence</strong> to select a single region of interest fragment. -->
        <SelectedSurfaceSetting ></SelectedSurfaceSetting>
    </el-scrollbar>
</template>

<script>
    import GlobalSurfaceSetting from "./GlobalSurfaceSetting.vue";
    import SelectedSurfaceSetting from "./SelectedSurfaceSetting.vue";
    // import CartoonSetting from "./CartoonSetting.vue";

    export default {
        name: "StructureSetting",
        data() {
            return {
                surface_visual: true,
                winHeight: window.innerHeight - 90 + "px",
                global_color: "",
                surface_color: "",
                selection_color: "",
                global_background: "#FFFFFF",
                global_structure_representation: "Cartoon",
                selection_structure_representation: "Licorice",
                options_structure_representation: [{
                        value: "Cartoon",
                    },
                    {
                        value: "Ribbon",
                    },
                    {
                        value: "Rope",
                    },
                    {
                        value: "Tube",
                    },
                    {
                        value: "Trace",
                    },
                    {
                        value: "Ball+stick",
                    },
                    {
                        value: "Hyperball",
                    },
                    {
                        value: "Licorice",
                    },
                    {
                        value: "Line",
                    },
                    {
                        value: "Point",
                    },
                    {
                        value: "Backbone",
                    },
                    {
                        value: "Spacefill",
                    },
                    {
                        value: "Surface",
                    },
                    {
                        value: "Transparent",
                    },
                ],
                surface_type: "vws",
                options_surface_type: [{
                        value: "vws",
                    },
                    {
                        value: "sas",
                    },
                    {
                        value: "ms",
                    },
                    {
                        value: "av",
                    },
                ],
                surface_smooth: 1,
                surface_opacity: 0.1,
                surface_flat_shaded: false,
                surface_roughness: 1,
                surface_metalness: 0,
                surface_probe_radius: 1.5,
                surface_scale_factor: 2,
                surface_side: "Front",
                surface_contour: false,
                surface_low_resolution: false,
                options_surface_side: [{
                        value: "Front",
                    },
                    {
                        value: "Back",
                    },
                    {
                        value: "Double",
                    },
                    // {'value': 'Select'},
                ],
                shape_map: {
                    Cartoon: "icon-font icon-cartoon",
                    Ribbon: "icon-font icon-bianzu3",
                    Rope: "icon-font icon-rope1",
                    Tube: "icon-font icon-tube",
                    Trace: "icon-font icon-trace",
                    "Ball+stick": "icon-font icon-danbaizhi",
                    Hyperball: "icon-font icon-jiaohu",
                    Licorice: "icon-font icon-lianjie",
                    Line: "icon-font icon-icon-",
                    Point: "icon-font icon-xian1",
                    Backbone: "icon-font icon-buguize",
                    Spacefill: "icon-font icon-spacefill",
                    Surface: "icon-font icon-bingdu",
                    Transparent: "el-icon-close",
                },
                shape_class: "icon-font icon-cartoon",
                predefineColors: [
                    "#ff4500",
                    "#ff8c00",
                    "#ffd700",
                    "#90ee90",
                    "#00ced1",
                    "#1e90ff",
                    "#c71585",
                ],
                selected_effect: "Double",
                options_selected_effect: [{
                        value: "Double",
                    },
                    {
                        value: "Surface",
                    },
                    {
                        value: "Current selected representation",
                    },
                ],
                selected_focus: false,
                global_focus: false,
                global_animation: false,
            };
        },
        watch: {
            "$store.state.left_aside_width"(val) {
                this.switch_width = val;
            },
            global_structure_representation() {
                this.update_global_setting();
            },
            global_color() {
                this.update_global_setting();
            },
            global_background() {
                this.update_global_setting();
            },
            global_focus(val) {
                if (val) this.selected_focus = false;
                else this.selected_focus = true;
                this.update_global_setting();
            },
            global_animation() {
                this.update_global_setting();
            },
            selection_structure_representation() {
                this.update_selection_setting();
            },
            selection_color() {
                this.update_selection_setting();
            },
            selected_effect() {
                this.update_selection_setting();
            },
            selected_focus(val) {
                if (val) this.global_focus = false;
                this.update_selection_setting();
            },
            surface_visual() {
                this.update_surface_setting();
            },
            surface_type() {
                this.update_surface_setting();
            },
            surface_color() {
                this.update_surface_setting();
            },
            surface_opacity() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_contour() {
                this.update_surface_setting();
            },
            surface_side() {
                this.update_surface_setting();
            },
            surface_smooth() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_roughness() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_metalness() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_probe_radius() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_scale_factor() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.update_surface_setting();
                }, 300);
            },
            surface_flat_shaded() {
                this.update_surface_setting();
            },
        },
        components: {
            GlobalSurfaceSetting,
            SelectedSurfaceSetting,
            // CartoonSetting,
        },
        mounted() {
            //
            this.init();
        },
        methods: {
            init() {
                this.update_surface_setting();
                this.update_selection_setting();
                this.update_global_setting();
            },
            update_global_setting() {
                let global_setting = this.$store.state.structure_global_setting;
                let cur_repr = this.global_structure_representation;
                if (this.global_structure_representation === "Transparent") cur_repr = "base";
                (global_setting["representation"] = cur_repr),
                (global_setting["color"] = this.global_color),
                (global_setting["background"] = this.global_background),
                (global_setting["animation"] = this.global_animation),
                (global_setting["focus"] = this.global_focus),
                this.$store.commit("StructureGlobalSettingMutation", global_setting);
                // console.log(">>>>>>", this.$store.state.structure_global_setting);
            },
            update_selection_setting() {
                let selection_setting = {
                    representation: this.selection_structure_representation,
                    color: this.selection_color,
                    effect: this.selected_effect,
                    focus: this.selected_focus,
                };
                this.$store.commit("StructureSelectionSettingMutation", selection_setting);
                // console.log(">>>>>>", this.$store.state.structure_selection_setting);
            },
            update_surface_setting() {
                // let surface_setting = {
                //     surface_visual: this.surface_visual,
                //     surface_type: this.surface_type,
                //     surface_color: this.surface_color,
                //     surface_opacity: this.surface_opacity,
                //     surface_contour: this.surface_contour,
                //     surface_side: this.surface_side,
                //     surface_smooth: this.surface_smooth,
                //     surface_roughness: this.surface_roughness,
                //     surface_metalness: this.surface_metalness,
                //     surface_probe_radius: this.surface_probe_radius,
                //     surface_scale_factor: this.surface_scale_factor,
                //     surface_flat_shaded: this.surface_flat_shaded,
                // };
                // this.$store.commit("GlobalSurfaceSettingMutation", surface_setting);
            },
        },
    };
</script>

<style>
    .bm-table-ope .el-switch.is-checked .el-switch__core {
        border-color: #409eff;
        background-color: #409eff;
    }

    .bm-structure-table-name {
        width: 170px;
        text-align: right;
        background: #F1F2F6;
    }

    .bm-table-ope .el-switch__core {
        margin: 0;
        position: relative;
        width: 180px !important;
        height: 21px !important;
        border: 0px solid #dcdfe6 !important;
        outline: 0;
        border-radius: 0px !important;
        box-sizing: border-box;
        background: #dcdfe6;
        transition: border-color 0.3s, background-color 0.3s;
        vertical-align: middle;
    }

    .bm-table-ope .el-switch {
        margin: 5px 10px 5px 10px;
    }

    .el-switch__core:after {
        content: "";
        position: absolute;
        top: 1px;
        left: 1px;
        border-radius: 0 !important;
        transition: all 0.3s;
        width: 16px !important;
        height: 19px !important;
        background-color: #fff;
    }

    .bm-table-ope .el-color-picker__color-inner {
        border-radius: 0px !important;
    }

    .bm-table-ope .el-color-picker__trigger {
        margin: 5px 0 0 10px !important;
        height: 26px !important;
        width: 200px !important;
        /* padding: 5px 10px 0px 10px; */
        /*border: 1px solid #E0DDD4;*/
        /*border-top: 1px solid #E0DDD4;*/
        /*border-bottom: 1px solid #E0DDD4;*/
    }

    .bm-table-ope .el-color-picker {
        height: 26px !important;
    }

    .bm-table-ope .el-slider__runway {
        width: 100%;
        height: 6px;
        margin: 5px 0;
        background-color: #e4e7ed;
        border-radius: 3px;
        position: relative;
        cursor: pointer;
        vertical-align: middle;
    }

    /* .el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #409EFF;
        border: 1px solid #DCDFE6;
        color: #606266 ;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
    } */

    .el-color-dropdown__btn {
        background: #409EFF !important;
    }

    .el-color-dropdown__link-btn {
        border: 1px solid #DCDFE6 !important;
        color: #606266 !important;
    }

    .bm-table-ope .el-slider__bar {
        height: 6px;
        background-color: #747d8c;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        position: absolute;
    }

    .bm-table-ope .el-slider__button {
        width: 16px;
        height: 16px;
        border: 2px solid #747d8c;
        background-color: #fff;
        border-radius: 50%;
        transition: 0.2s;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>